import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Alert, AlertDescription } from "../components/ui/alert";
import SEO from "../components/SEO";
import { Emblem } from "../components/Emblem";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [mockLink, setMockLink] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setMsg(""); setMockLink("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message || "Si el email existe, recibirás un enlace para restablecer la contraseña.");
      if (data.mock_reset_link) setMockLink(data.mock_reset_link);
    } catch (e) { setErr(formatApiError(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex bg-ink relative overflow-hidden">
      <SEO title="Recuperar contraseña" path="/forgot-password" />
      <div className="fixed inset-0 bg-aurora pointer-events-none" />
      <div className="fixed inset-0 bg-dot-grid pointer-events-none opacity-40" />

      <div className="flex-1 flex items-center justify-center p-6 sm:p-12 relative z-10">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center gap-2.5 mb-10 w-fit">
            <Emblem className="h-9 w-9" />
            <span className="font-display font-extrabold text-white tracking-tight">TestOpoGuardiaCivil</span>
          </Link>

          <h1 className="font-display text-4xl font-extrabold text-white tracking-tighter">Recuperar contraseña</h1>
          <p className="mt-2 text-sm text-slate-400">
            Introduce tu email y te enviaremos un enlace para restablecer tu contraseña.
          </p>

          {err && <Alert variant="destructive" className="mt-6 border-red-900/50 bg-red-950/40 text-red-200" data-testid="forgot-error"><AlertDescription>{err}</AlertDescription></Alert>}

          {msg ? (
            <div className="mt-8 p-5 border border-emerald-700/30 bg-emerald-950/30 rounded-xl" data-testid="forgot-success">
              <div className="text-sm font-medium text-emerald-300">{msg}</div>
              {mockLink && (
                <div className="mt-4 pt-4 border-t border-emerald-800/30">
                  <div className="text-[10px] font-bold uppercase tracking-[0.22em] text-gcgold mb-2 font-mono">Modo DEV — Enlace</div>
                  <Link to={mockLink.replace(/^https?:\/\/[^/]+/, "")} className="text-xs text-gcgold-light underline font-mono break-all" data-testid="mock-reset-link">
                    {mockLink}
                  </Link>
                </div>
              )}
            </div>
          ) : (
            <form onSubmit={onSubmit} className="mt-8 space-y-5">
              <div>
                <Label htmlFor="email" className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 font-mono">Email</Label>
                <Input
                  id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@email.com"
                  className="mt-2 h-12 bg-ink-800 border-white/10 text-white placeholder:text-slate-600 focus:border-gcgold/40 focus:ring-gcgold/20 rounded-xl"
                  data-testid="forgot-email-input"
                />
              </div>
              <Button type="submit" disabled={loading}
                className="w-full h-12 bg-gcgreen hover:bg-gcgreen-light text-white font-semibold rounded-xl shadow-[0_0_40px_-8px_rgba(10,92,54,0.7)] transition-all"
                data-testid="forgot-submit-button">
                {loading ? "Enviando..." : "Enviar enlace de recuperación"}
              </Button>
            </form>
          )}

          <div className="mt-6 text-sm text-slate-500">
            <Link to="/login" className="text-gcgold hover:text-gcgold-light font-semibold">← Volver a iniciar sesión</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
